import { type FC, type MouseEvent } from "react";

const SHOWN_PAGES = 3;

// "p. 15", "pp. 15, 24, 54", or "pp. 15, 24, 54 +2" with the rest on hover.
export const citationChipLabel = (pages: number[]): string => {
  if (pages.length === 1) return `p. ${String(pages[0])}`;
  const shown = pages.slice(0, SHOWN_PAGES).join(", ");
  const rest = pages.length - SHOWN_PAGES;
  return rest > 0 ? `pp. ${shown} +${String(rest)}` : `pp. ${shown}`;
};

// The pages cited at one position, as one small chip after the text.
export const CitationChip: FC<{ pages: number[]; onPress(): void }> = ({
  pages,
  onPress,
}) => {
  if (pages.length === 0) return null;
  const press = (event: MouseEvent) => {
    event.stopPropagation();
    onPress();
  };

  return (
    <button
      type="button"
      onClick={press}
      title={pages.length > 1 ? `Pages ${pages.join(", ")}` : undefined}
      className="ml-1 rounded bg-slate-100 px-1.5 align-[1px] text-[10.5px] leading-[17px] font-semibold whitespace-nowrap text-slate-500 transition-colors hover:bg-indigo-50 hover:text-indigo-700"
    >
      {citationChipLabel(pages)}
    </button>
  );
};
